import { useIsLogoutInFlight } from '@/lib/authInFlight';
import { type Dispatch, store } from '@/store';
import { logger } from '@/utils/logger/logger';
import { jwtDecode } from 'jwt-decode';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useCheckTokenOnTabFocus = () => {
  const token = store.select.auth.getToken(store.getState());
  const dispatch = useDispatch<Dispatch>();
  const logout = dispatch.auth.logout;
  const isLoggingOut = useIsLogoutInFlight();

  const logoutWhenExpired = useCallback(() => {
    if (isLoggingOut) {
      return;
    }
    void logout();
  }, [logout, isLoggingOut]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        try {
          if (!token) {
            return;
          }
          const decoded = jwtDecode(token);
          const exp = decoded.exp;
          const now = Math.floor(Date.now() / 1000);
          if (!exp) {
            return;
          }
          // if token is expired, logout
          if (exp < now) {
            logger.info('Token has expired.');
            logoutWhenExpired();
          }
        } catch (err) {
          logger.info('Invalid token', err);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [token, logoutWhenExpired]);
};
